export const STATE_LIST = [
  {
    code: 'JHR',
    name: 'Johor',
    cities: [
      { name: 'API-API' },
      { name: 'AYER BALOI' },
      { name: 'AYER HITAM' },
      { name: 'AYER MASIN' },
      { name: 'BAGAN' },
      { name: 'BANDAR JOHOR BHARU' },
      { name: 'BEKOK' },
      { name: 'BENUT' },
      { name: 'BUKIT BATU' },
      { name: 'BUKIT GAMBIR' },
      { name: 'BUKIT KEPONG' },
      { name: 'BUKIT SERAMPANG' },
      { name: 'BULOH KASAP' },
      { name: 'BUNKIT KANGKAR' },
      { name: 'CHAAH' },
      { name: 'CHAAH BAHRU' },
      { name: 'GEMAS' },
      { name: 'GEMERAH' },
      { name: 'GERISEK' },
      { name: 'JABI' },
      { name: 'JALAN BAKRI' },
      { name: 'JELUTONG' },
      { name: 'JEMALUANG' },
      { name: 'JEMENTAH' },
      { name: 'JERAM BATU' },
      { name: 'JOHOR LAMA' },
      { name: 'JORAK' },
      { name: 'KAHANG' },
      { name: 'KAMBAU' },
      { name: 'KAMPUNG BAHRU' },
      { name: 'KEBUN BAHRU' },
      { name: 'KESANG' },
      { name: 'KESANG, TG GADING' },
      { name: 'KLUANG TOWN' },
      { name: 'KOTA TINGGI' },
      { name: 'KULAI TOWN' },
      { name: 'KUNDANG ULU' },
      { name: 'LABIS' },
      { name: 'LAYANG-LAYANG' },
      { name: 'LENGA' },
      { name: 'LENGGOR' },
      { name: 'LINAU' },
      { name: 'LUBOK' },
      { name: 'MACHAP' },
      { name: 'MERSING TOWN' },
      { name: 'MINYAK BEKU' },
      { name: 'MUAR TOWN' },
      { name: 'NIYOR' },
      { name: 'PADANG ENDAU' },
      { name: 'PALOH' },
      { name: 'PANTAI TIMUR' },
      { name: 'PARIT BAKAR' },
      { name: 'PARIT BUNGA' },
      { name: 'PARIT JAWA' },
      { name: 'PEKAN RAWANG' },
      { name: 'PENGERANG' },
      { name: 'PENGKALAN RAJA' },
      { name: 'PENYABONG' },
      { name: 'PESERAI' },
      { name: 'PLENTONG' },
      { name: 'POGOH' },
      { name: 'PONTIAN' },
      { name: 'PULAI' },
      { name: 'RENGGAM' },
      { name: 'RIMBA TERJUN' },
      { name: 'SAGIL' },
      { name: 'SEDENAK' },
      { name: 'SEDILI BESAR' },
      { name: 'SEDILI KECIL' },
      { name: 'SEMBRONG' },
      { name: 'SENAI' },
      { name: 'SERI MENANTI' },
      { name: 'SERKAT' },
      { name: 'SERMIN' },
      { name: 'SEROM' },
      { name: 'SIMPANG KANAN' },
      { name: 'SIMPANG KIRI' },
      { name: 'SRI GADING' },
      { name: 'SRI MEDAN' },
      { name: 'SUNGAI BALANG' },
      { name: 'SUNGAI KARANG' },
      { name: 'SUNGAI KLUANG' },
      { name: 'SUNGAI MATI' },
      { name: 'SUNGAI PINGGAN' },
      { name: 'SUNGAI PUNGGOR' },
      { name: 'SUNGAI RAYA' },
      { name: 'SUNGAI SEGAMAT' },
      { name: 'SUNGAI TERAP' },
      { name: 'SUNGAI TIRAM' },
      { name: 'TANGKAK' },
      { name: 'TANJUNG AGAS' },
      { name: 'TANJUNG KUPANG' },
      { name: 'TANJUNG SEMBERONG' },
      { name: 'TANJUNG SURAT' },
      { name: 'TEBRAU' },
      { name: 'TENGGAROH' },
      { name: 'TENGLU' },
      { name: 'TRIANG' },
      { name: 'ULU BENUT' },
      { name: 'ULU SUNGAI JOHOR' },
      { name: 'ULU SUNGAI SEDILI BESAR' },
    ],
  },
  {
    code: 'KDH',
    name: 'Kedah',
    cities: [
      { name: 'AH' },
      { name: 'AIR PUTEH' },
      { name: 'ALOR MALAI' },
      { name: 'ALOR MERAH' },
      { name: 'ANAK BUKIT' },
      { name: 'BAGAN SAMAK' },
      { name: 'BAGAN SENA' },
      { name: 'BAKAI' },
      { name: 'BALING TOWN' },
      { name: 'BATANG TUNGGANG KANAN' },
      { name: 'BATANG TUNGGANG KIRI' },
      { name: 'BELIMBING KANAN' },
      { name: 'BELIMBING KIRI' },
      { name: 'BINJAL' },
      { name: 'BONGOR' },
      { name: 'BUJANG' },
      { name: 'BUKIT LADA' },
      { name: 'BUKIT MERIAM' },
      { name: 'BUKIT PINANG' },
      { name: 'BUKIT RAYA' },
      { name: 'BUKIT TINGGI' },
      { name: 'DERANG' },
      { name: 'DERGA' },
      { name: 'DULANG' },
      { name: 'GAJAH MATI' },
      { name: 'GELONG' },
      { name: 'GUAR KEPAYANG' },
      { name: 'GUNONG' },
      { name: 'GURUN' },
      { name: 'HAJI KUDONG' },
      { name: 'HOSBA' },
      { name: 'HUTAN KAMPUNG' },
      { name: 'JABI' },
      { name: 'JENERI' },
      { name: 'JERAM' },
      { name: 'JERLUN' },
      { name: 'JITRA' },
      { name: 'JUNJUNG' },
      { name: 'KANGKONG' },
      { name: 'KARANGAN' },
      { name: 'KELADI' },
      { name: 'KOTA' },
      { name: 'KOTA SETAR' },
      { name: 'KUALA' },
      { name: 'KUALA KEDAH' },
      { name: 'KUBANG PASU TOWN' },
      { name: 'KUBANG ROTAN' },
      { name: 'KULIM TOWN' },
      { name: 'KUPANG' },
      { name: 'KURONG HITAM' },
      { name: 'LANGGAR' },
      { name: 'LENGKUAS' },
      { name: 'LEPAI' },
      { name: 'LESONG' },
      { name: 'LIMBONG' },
      { name: 'LUNAS' },
      { name: 'MAHANG' },
      { name: 'MALAU' },
      { name: 'MERBOK' },
      { name: 'MERGONG' },
      { name: 'NAGA' },
      { name: 'NAGALILIT' },
      { name: 'PADANG CHINA' },
      { name: 'PADANG HANG' },
      { name: 'PADANG KERBAU' },
      { name: 'PADANG LALANG' },
      { name: 'PADANG MEHA' },
      { name: 'PADANG PELIANG' },
      { name: 'PADANG PERAHU' },
      { name: 'PADANG PUSING' },
      { name: 'PADANG TEMAK' },
      { name: 'PADANG TERAP KANAN' },
      { name: 'PADANG TERAP KIRI' },
      { name: 'PEDU' },
      { name: 'PEKAN BATU LIMA SIK' },
      { name: 'PEKAN CHAROK PADANG' },
      { name: 'PEKAN GAJAH PUTEH' },
      { name: 'PEKAN GULAU' },
      { name: 'PEKULA' },
      { name: 'PELUBANG' },
      { name: 'PENGKALAN KUNDOR' },
      { name: 'PERING' },
      { name: 'PINANG TUNGGAL' },
      { name: 'PULAI' },
      { name: 'PUMPONG' },
      { name: 'PUTAT' },
      { name: 'RAMBAI' },
      { name: 'RANTAU PANJANG' },
      { name: 'RELAU' },
      { name: 'SALA BESAR' },
      { name: 'SALA KERCHIL' },
      { name: 'SANGLANG' },
      { name: 'SEDIM' },
      { name: 'SELAMA' },
      { name: 'SEMELING' },
      { name: 'SERDANG' },
      { name: 'SEUNGAU SELUANG' },
      { name: 'SIDAM KANAN' },
      { name: 'SIDAM KIRI' },
      { name: 'SIK' },
      { name: 'SIK TOWN' },
      { name: 'SIMPOR' },
      { name: 'SINGKIR' },
      { name: 'SIONG' },
      { name: 'SOK' },
      { name: 'SUNGAI BAHARU' },
      { name: 'SUNGAI BATU' },
      { name: 'SUNGAI DAUN' },
      { name: 'SUNGAI KECHIL HILIR' },
      { name: 'SUNGAI LAKA' },
      { name: 'SUNGAI PASIR' },
      { name: 'SUNGAI PETANI' },
      { name: 'SUNGAI ULAR' },
      { name: 'TAJAR' },
      { name: 'TAKAI' },
      { name: 'TAWAR' },
      { name: 'TEBENGAU' },
      { name: 'TELAGA MAS' },
      { name: 'TELOI KANAN' },
      { name: 'TELOI KIRI' },
      { name: 'TELOK CHENGAI' },
      { name: 'TELOK KECHAI' },
      { name: 'TEMIN' },
      { name: 'TERAP' },
      { name: 'TITI GAJAH' },
      { name: 'TOBIAR' },
      { name: 'TOLAK' },
      { name: 'TUIALANG' },
      { name: 'TUNJANG' },
      { name: 'WANG TEPUS' },
    ],
  },
  {
    code: 'KTN',
    name: 'Kelantan',
    cities: [
      { name: 'ALOR PASIR' },
      { name: 'BADANG' },
      { name: 'BANDAR BARU GUA MUSANG' },
      { name: 'BANDAR KOTA BHARU' },
      { name: 'BANDAR UTAMA GUA MUSANG' },
      { name: 'BANGGU' },
      { name: 'BATU MENGKEBANG' },
      { name: 'BELIMBING' },
      { name: 'BUKIT ABAL' },
      { name: 'BUKIT AWANG' },
      { name: 'BUKIT JAWA' },
      { name: 'BUKIT MARAK' },
      { name: 'BUNUT SUSU' },
      { name: 'CHETOK' },
      { name: 'DABONG' },
      { name: 'DEWAN BETA' },
      { name: 'GONG DATOK' },
      { name: 'GUA MUSANG OLD TOWN' },
      { name: 'GUAL PERIOK' },
      { name: 'GUGUSAN CHIKU' },
      { name: 'GUGUSAN PALOH' },
      { name: 'GUGUSANG ARING' },
      { name: 'JELAWAT' },
      { name: 'JELI TOWN' },
      { name: 'JERAM' },
      { name: 'KADOK' },
      { name: 'KAMPUNG BALAI' },
      { name: 'KANGKONG' },
      { name: 'KEMUMIN' },
      { name: 'KETEREH' },
      { name: 'KOTA' },
      { name: 'KUALA BALAH' },
      { name: 'KUBANG GADONG' },
      { name: 'KUBANG KERIAN' },
      { name: 'KUBANG SEPAT' },
      { name: 'LABOK' },
      { name: 'LEMAL' },
      { name: 'LIMBAT' },
      { name: 'LIMBONGAN (PASIR PUTEH TOWN)' },
      { name: 'OLAK JERAM' },
      { name: 'PADANG PAK AMAT' },
      { name: 'PANGKAL MELERET' },
      { name: 'PANJI' },
      { name: 'PANYIT' },
      { name: 'PASIR MAS' },
      { name: 'PENDEK' },
      { name: 'PERINGAT' },
      { name: 'PERUPOK' },
      { name: 'PULAI CHONGDONG' },
      { name: 'RANTAU PANJANG' },
      { name: 'SALOR' },
      { name: 'SEMERAK' },
      { name: 'SERING' },
      { name: 'TAMAN SAUJANA HARMONI' },
      { name: 'TEMANGAN' },
      { name: 'ULU SAT' },
    ],
  },
  {
    code: 'KUL',
    name: 'Kuala Lumpur',
  },
  {
    code: 'MLK',
    name: 'Melaka',
    cities: [
      { name: 'AIR PANAS' },
      { name: 'ALAI' },
      { name: 'AYER MOLEK' },
      { name: "AYER PA'ABAS" },
      { name: 'BACHANG' },
      { name: 'BALAI PANJANG' },
      { name: 'BANDAR MELAKA' },
      { name: 'BATANG MELAKA' },
      { name: 'BATU BERENDAM' },
      { name: 'BELIMBING' },
      { name: 'BERINGIN' },
      { name: 'BERTAM' },
      { name: 'BRISU' },
      { name: 'BUKIT BARU' },
      { name: 'BUKIT KATIL' },
      { name: 'BUKIT LINTANG' },
      { name: 'BUKIT PIATU' },
      { name: 'BUKIT RAMBAI' },
      { name: 'BUKIT SENGGEH' },
      { name: 'CHABAU' },
      { name: 'CHENG' },
      { name: 'CHINCHIN' },
      { name: 'CHOCHONG' },
      { name: 'DURIAN TUNGGAL' },
      { name: 'DUYONG' },
      { name: 'GADEK' },
      { name: 'JASIN' },
      { name: 'JUS' },
      { name: 'KANDANG' },
      { name: 'KELEMAK' },
      { name: 'KEMUNING' },
      { name: 'KESANG' },
      { name: 'KLEBANG BESAR' },
      { name: 'KLEBANG KECIL' },
      { name: 'KRUBONG' },
      { name: 'KUALA LINGGI' },
      { name: 'KUALA SUNGAI BARU' },
      { name: 'LENDU' },
      { name: 'MACHAP' },
      { name: 'MASJID TANAH' },
      { name: 'MELAKA PINDAH' },
      { name: 'MELEKEK' },
      { name: 'MERLIMAU' },
      { name: 'NYALAS' },
      { name: 'PADANG SEBANG' },
      { name: 'PADANG TEMU' },
      { name: 'PARIT MELANA' },
      { name: 'PAYA RUMPUT' },
      { name: 'PEGOH' },
      { name: 'PERINGGIT' },
      { name: 'PERNU' },
      { name: 'PULAU SEBANG' },
      { name: 'RAMUAN CINA BESAR' },
      { name: 'RAMUAN CINA KECIL' },
      { name: 'REMBIA' },
      { name: 'RIM' },
      { name: 'SEBATU' },
      { name: 'SELANDAR' },
      { name: 'SEMABOK' },
      { name: 'SEMPANG' },
      { name: 'SEMUJOK' },
      { name: 'SERKAM' },
      { name: 'SUNGAI BARU HILIR' },
      { name: 'SUNGAI BARU TENGAH' },
      { name: 'SUNGAI BARU ULU' },
      { name: 'SUNGAI PETAI' },
      { name: 'SUNGAI RAMBAI' },
      { name: 'SUNGAI SIPUT' },
      { name: 'SUNGAI UDANG' },
      { name: 'SUNGAU BULUH' },
      { name: 'TABOH NANING' },
      { name: 'TANGGA BATU' },
      { name: 'TANJONG MINYAK' },
      { name: 'TANJUNG KLING' },
      { name: 'TANJUNG RIMAU' },
      { name: 'TEBONG' },
      { name: 'TEDONG' },
      { name: 'TELOK MAS' },
      { name: 'UJONG PASIR' },
      { name: 'UMBAI' },
    ],
  },
  {
    code: 'NSN',
    name: 'Negeri Sembilan',
    cities: [
      { name: 'AMPANG TINGGI' },
      { name: 'AMPANGAN' },
      { name: 'AYER KUNING' },
      { name: 'BATU HAMPAR' },
      { name: 'BONGEK' },
      { name: 'CHEMBONG' },
      { name: 'CHENGKAU' },
      { name: 'GADONG' },
      { name: 'GEMAS' },
      { name: 'GEMENCHEH' },
      { name: 'GLAMI LEMI' },
      { name: 'JELAI' },
      { name: 'JIMAH' },
      { name: 'JOHOL' },
      { name: 'JUASSEH' },
      { name: 'KENABOI' },
      { name: 'KEPIS' },
      { name: 'KERU' },
      { name: 'KUALA JEMPOL' },
      { name: 'KUALA KLAWANG (CAPITAL)' },
      { name: 'KUNDUR' },
      { name: 'LABU' },
      { name: 'LANGKAP' },
      { name: 'LEGONG HILIR' },
      { name: 'LEGONG HUU' },
      { name: 'LENGGENG' },
      { name: 'LINGGI' },
      { name: 'MIKU' },
      { name: 'NERASAU' },
      { name: 'PANTAI' },
      { name: 'PARIT TINGGI' },
      { name: 'PASIR PANJANG' },
      { name: 'PEDAS' },
      { name: 'PERADONG' },
      { name: 'PERTANG' },
      { name: 'PILAH (CAPITAL)' },
      { name: 'PILIN' },
      { name: 'PORT DICKSON TOWN' },
      { name: 'RANTAU' },
      { name: 'RASAH' },
      { name: 'REPAH' },
      { name: 'ROMPIN' },
      { name: 'SELEMAK' },
      { name: 'SEMERBOK' },
      { name: 'SEPRI' },
      { name: 'SEREMBAN cities' },
      { name: 'SERI MENANTI' },
      { name: 'SERTING LLIR (CAPITAL)' },
      { name: 'SERTING ULU' },
      { name: 'SETUL' },
      { name: 'SI RUSA' },
      { name: 'TAMPIN TENGAH' },
      { name: 'TANJUNG KELING' },
      { name: 'TEBONG' },
      { name: 'TERACHI' },
      { name: 'TITIAN BINTANGOR' },
      { name: 'TRAING HILIR' },
      { name: 'ULU JEMPOL' },
      { name: 'ULU KLAWANG' },
      { name: 'ULU MUAR' },
      { name: 'ULU TRIANG' },
    ],
  },
  {
    code: 'PHG',
    name: 'Pahang',
    cities: [
      { name: 'BANGAU' },
      { name: 'BATU TALAM' },
      { name: 'BATU YON' },
      { name: 'BEBAR' },
      { name: 'BENTONG' },
      { name: 'BERA ' },
      { name: 'BESERAH' },
      { name: 'BUDU' },
      { name: 'BUKIT SEGUMPAL' },
      { name: 'BURAU' },
      { name: 'CHEKA' },
      { name: 'CHENOR' },
      { name: 'DONG' },
      { name: 'ENDAU' },
      { name: 'GALI' },
      { name: 'GANCHONG' },
      { name: 'GUA' },
      { name: 'HULU CHEKA' },
      { name: 'HULU DONG' },
      { name: 'HULU JELAI' },
      { name: 'HULU TEMBELING' },
      { name: 'JENDERAK' },
      { name: 'KECHAU' },
      { name: 'KELOLA' },
      { name: 'KERATONG' },
      { name: 'KERDAU' },
      { name: 'KERTAU' },
      { name: 'KUALA KUANTAN' },
      { name: 'KUALA LIPIS' },
      { name: 'KUALA PAHANG' },
      { name: 'KUALA TEMBELING' },
      { name: 'LANGGAR' },
      { name: 'LEBAK' },
      { name: 'LEPAR' },
      { name: 'LIPAT KAJANG' },
      { name: 'LUIT (CAPITAL)' },
      { name: 'MENTAKAB' },
      { name: 'PAHANG TUA' },
      { name: 'PEDAH' },
      { name: 'PEKAN (CAPITAL)' },
      { name: 'PELANGAI' },
      { name: 'PENJOM' },
      { name: 'PENOR' },
      { name: 'PENYOR' },
      { name: 'PERAK' },
      { name: 'PONTIAN' },
      { name: 'PULAU MANIS' },
      { name: 'PULAU RUSA' },
      { name: 'PULAU TAWAR' },
      { name: 'ROMPIN' },
      { name: 'SABAI' },
      { name: 'SANGGANG' },
      { name: 'SEGA' },
      { name: 'SEMANTAN' },
      { name: 'SEMANTAN HULU' },
      { name: 'SONGSANG' },
      { name: 'SUNGAI KARANG' },
      { name: 'TANAH RATA' },
      { name: 'TANJONG BESAR' },
      { name: 'TEBING TINGGI' },
      { name: 'TEH' },
      { name: 'TELANG' },
      { name: 'TEMAI' },
      { name: 'TEMBELING' },
      { name: 'TERAS' },
      { name: 'TERIANG' },
      { name: 'TIOMAN' },
      { name: 'ULU KUANTAN' },
      { name: 'ULU LEPAR' },
    ],
  },
  {
    code: 'PRK',
    name: 'Perak',
    cities: [
      { name: 'BAGAN DATUK' },
      { name: 'BAGAN SERAI' },
      { name: 'BAGAN TIANG' },
      { name: 'BANDAR' },
      { name: 'BATANG PADANG' },
      { name: 'BATU KURAU' },
      { name: 'BELANJA' },
      { name: 'BELUKAR SEMANG' },
      { name: 'BELUM' },
      { name: 'BERIAH' },
      { name: 'BERUAS' },
      { name: 'BIDOR' },
      { name: 'BOTA' },
      { name: 'BUKIT GANTANG' },
      { name: 'CHANGKAT JONG' },
      { name: 'CHEGAR GALAH' },
      { name: 'CHENDERIANG' },
      { name: 'DURIAN PIPIT' },
      { name: 'DURIAN SEBATANG' },
      { name: 'GERIK' },
      { name: 'GUNUNG SEMANGGOL' },
      { name: 'HULU KINTA' },
      { name: 'HUTAN MELINTANG' },
      { name: 'JAYA BARU' },
      { name: 'KAMPAR' },
      { name: 'KAMPUNG BUAIA' },
      { name: 'KAMPUNG GAJAH' },
      { name: 'KENERING' },
      { name: 'KERUNAI' },
      { name: 'KOTA LAMA KANAN' },
      { name: 'KOTA LAMA KIRI' },
      { name: 'KOTA SETIA' },
      { name: 'KUALA KURAU' },
      { name: 'LABU KUBONG' },
      { name: 'LAMBOR KANAN' },
      { name: 'LAMBOR KIRI' },
      { name: 'LAYANG-LAYANG' },
      { name: 'LEKIR' },
      { name: 'LENGGONG' },
      { name: 'LUBUK MERBAU' },
      { name: 'LUMUT' },
      { name: 'MATANG' },
      { name: 'PARIT BUNTAR' },
      { name: 'PASIR PANJANG HULU' },
      { name: 'PASRI SALAK' },
      { name: 'PENGKALAN BAHARU' },
      { name: 'PENGKALAN HULU' },
      { name: 'PULAI TIGA' },
      { name: 'PULAU KAMIRI' },
      { name: 'RUNGKUP' },
      { name: 'SAYONG' },
      { name: 'SELINSING' },
      { name: 'SENGGANG' },
      { name: 'SITIAWAN' },
      { name: 'SLIM' },
      { name: 'SUNGAI DURIAN' },
      { name: 'SUNGAI MANIK' },
      { name: 'SUNGAI RAIA' },
      { name: 'SUNGAI SIPUT' },
      { name: 'SUNGAI TERAP' },
      { name: 'SUNGAI TINGGI' },
      { name: 'SUNGKAI' },
      { name: 'TANJUNG PIANDANG' },
      { name: 'TANJUNG TUALANG' },
      { name: 'TEJA' },
      { name: 'TELUK BHARU' },
      { name: 'TEMELONG' },
      { name: 'TEMENGGOR' },
      { name: 'TRONG' },
      { name: 'ULU BERNAM' },
    ],
  },
  {
    code: 'PLS',
    name: 'Perlis',
    cities: [
      { name: 'ARAU' },
      { name: 'KAKI BUKIT' },
      { name: 'KANGAR' },
      { name: 'KUALA PERLIS' },
      { name: 'PADANG BESAR' },
      { name: 'SIMPANG AMPAT' },
    ],
  },
  {
    code: 'PNG',
    name: 'Penang',
    cities: [
      { name: 'AIR ITAM' },
      { name: 'ALMA' },
      { name: 'ARA KUDA' },
      { name: 'BAGAN' },
      { name: 'BAGAN AYER ITAM' },
      { name: 'BAGAN DALAM' },
      { name: 'BANDAR PERDA' },
      { name: 'BANGAN JERMAL' },
      { name: 'BATU FERINGGHI' },
      { name: 'BATU ITAM' },
      { name: 'BATU KAWAN' },
      { name: 'BATU LANCHANG' },
      { name: 'BATU MAUNG' },
      { name: 'BAYAN LEPAS' },
      { name: 'BERAPIT' },
      { name: 'BERTAM' },
      { name: 'BUKIT BALIK PULAU' },
      { name: 'BUKIT GEMERUH' },
      { name: 'BUKIT GINTING' },
      { name: 'BUKIT JELUTONG' },
      { name: 'BUKIT MINYAK INDUSTRIAL ZONE' },
      { name: 'BUKIT PASIR PANJANG' },
      { name: 'BUKIT RELAU' },
      { name: 'BUKIT TAMBUN' },
      { name: 'BUKIT TENGAH' },
      { name: 'BUTTERWORTH' },
      { name: 'DATARAN GINTING' },
      { name: 'GELUGOR' },
      { name: 'GUAR PERAHU' },
      { name: 'JALAN BETEK' },
      { name: 'JAWI' },
      { name: 'JELUTONG' },
      { name: 'JURU' },
      { name: 'KAMPONG PAYA' },
      { name: 'KEPALA BATAS' },
      { name: 'KONGSI' },
      { name: 'KUBANG SEMANG' },
      { name: 'MACHANG BUBOK' },
      { name: 'MENGKUANG' },
      { name: 'MERTAJAM HILL' },
      { name: 'NIBONG TEBAL' },
      { name: 'PANTAI ACHEH' },
      { name: 'PAYA TERUBONG' },
      { name: 'PENAGA' },
      { name: 'PERMATANG BERANGAN' },
      { name: 'PERMATANG PASIR' }, // SAME
      { name: 'PERMATANG PAUH' },
      { name: 'PERMATANG TINGGI' },
      { name: 'PINANG TUNGGAL' },
      { name: 'PONDOK UPEH' },
      { name: 'PULAU BETONG' },
      { name: 'PULAU TIKUS' },
      { name: 'SAMA GAGAH' },
      { name: 'SEBERANG JAYA' },
      { name: 'SIMPANG AMPAT' },
      { name: 'SUNGAI ACHEH' },
      { name: 'SUNGAI BAKAP' },
      { name: 'SUNGAI BURONG' },
      { name: 'SUNGAI DUA' },
      { name: 'SUNGAI PINANG' },
      { name: 'SUNGAI PUYU' },
      { name: 'SUNGAI RUSA' },
      { name: 'TAMAN PAUH' },
      { name: 'TANAH LIAT' },
      { name: 'TANJUNG BUNGAH' },
      { name: 'TANJUNG TOKONG' },
      { name: 'TASEK GELUGOR' },
      { name: 'TELOK AIR TAWAR' },
      { name: 'TELOK BAHANG' },
      { name: 'TELOK KUMBAR' },
      { name: 'TITI TERAS' },
      { name: 'VALDOR' },
    ],
  },
  {
    code: 'PJY',
    name: 'Putrajaya',
  },
  {
    code: 'SGR',
    name: 'Selangor',
    cities: [
      { name: 'AMPANG' },
      { name: 'API-API' },
      { name: 'ARA DAMANSARA' },
      { name: 'BALAKONG' },
      { name: 'BANDAR BARU BANGI' },
      { name: 'BANDAR BARU KLANG' },
      { name: 'BANDAR SAUJANA PUTRA' },
      { name: 'BANDAR SRI DAMANSARA' },
      { name: 'BANDAR TUN HUSSEIN ONN' },
      { name: 'BANGI' },
      { name: 'BANTING' },
      { name: 'BATANG KALI' },
      { name: 'BATU' },
      { name: 'BATU 4' },
      { name: 'BATU CAVES' },
      { name: 'BERANANG' },
      { name: 'BESTARI JAYA' },
      { name: 'BUKIT BERUNTUNG' },
      { name: 'BUKIT KEMUNING' },
      { name: 'BUKIT RAJA' },
      { name: 'CHERAS' },
      { name: 'COUNTRY HEIGHTS' },
      { name: 'CYBERJAYA' },
      { name: 'DAMANSARA' },
      { name: 'DENGKIL' },
      { name: 'GLENMARIE COVE' },
      { name: 'GOMBAK' },
      { name: 'HULU BERNAM' },
      { name: 'IJOK' },
      { name: 'JERAM' },
      { name: 'JUGRA' },
      { name: 'KAJANG' },
      { name: 'KAMPUNG SUNGAI PUSU' },
      { name: 'KAPAR' },
      { name: 'KERLING' },
      { name: 'KOTA RAJA' },
      { name: 'KUALA KUBU BHARU' },
      { name: 'KUALA LUMPUR INTERNATIONAL AIRPORT' },
      { name: 'KUANG' },
      { name: 'KUNDANG' },
      { name: 'MERU' },
      { name: 'MORIB' },
      { name: 'PANDAMARAN' },
      { name: 'PASANGAN' },
      { name: 'PEKAN SEPANG' },
      { name: 'PELABUHANG KLANG' },
      { name: 'PETALING JAYA' },
      { name: 'PUCHONG' },
      { name: 'PUCHONG JAYA' },
      { name: 'PUCHONG PERDANA' },
      { name: 'PUNCAK ALAM' },
      { name: 'PUTRA HEIGHTS' },
      { name: 'RASA' },
      { name: 'RAWANG' },
      { name: 'SABAK' },
      { name: 'SALAK TINGGI' },
      { name: 'SEKINCHAN' },
      { name: 'SELAYANG' },
      { name: 'SEMENYIH' },
      { name: 'SERDANG' },
      { name: 'SERENDAH' },
      { name: 'SETAPAK' },
      { name: 'SHAH ALAM' },
      { name: 'SUBANG JAYA' },
      { name: 'SUNGAI AIR TAWAR' },
      { name: 'SUNGAI BESAR' },
      { name: 'SUNGAI BULOH' },
      { name: 'SUNGAI PANJANG' },
      { name: 'SUNGAI PELEK' },
      { name: 'TAMAN SRI NANDING' },
      { name: 'TANJUNG KARANG' },
      { name: 'TANJUNG SEPAT' },
      { name: 'TELOK MENENGU' },
      { name: 'TELUK DATOK' },
      { name: 'TELUK PANGLIMA GARANG' },
      { name: 'ULU KLANG' },
    ],
  },
  {
    code: 'TRG',
    name: 'Terengganu',
    cities: [
      { name: 'ABANG' },
      { name: 'ALUR RIMBAT' },
      { name: 'ATAS TOL' },
      { name: 'BANDAR' },
      { name: 'BANDAR MARANG' },
      { name: 'BANDI' },
      { name: 'BANGGUL' },
      { name: 'BATU BURUK' },
      { name: 'BATU RAKIT' },
      { name: 'BELARA' },
      { name: 'BESOL' },
      { name: 'BINJAI' },
      { name: 'BUKIT BESAR' },
      { name: 'BUKIT KENAK' },
      { name: 'BUKIT PAYONG' },
      { name: 'BUKIT PAYONG TOWN' },
      { name: 'BUKIT PUTERI' },
      { name: 'CABANG TIGA' },
      { name: 'CENERING' },
      { name: 'CHALUK' },
      { name: 'CHUKAI ( CAPITAL)' },
      { name: 'GELUGUR KEDAI' },
      { name: 'GELUGUR RAJA' },
      { name: 'GUNTUNG' },
      { name: 'HULU BERANG' },
      { name: 'HULU BESUT' },
      { name: 'HULU CHUKAI' },
      { name: 'HULU JABUR' },
      { name: 'HULU NERUS' },
      { name: 'HULU PAKA' },
      { name: 'HULU SETIU' },
      { name: 'HULU TELEMUNG' },
      { name: 'HULU TERENGGANU' },
      { name: 'JABI' },
      { name: 'JENAGUR' },
      { name: 'JENGAI' },
      { name: 'JERANGAU' },
      { name: 'JERUNG' },
      { name: 'KAMPUNG RAJA' },
      { name: 'KELUANG' },
      { name: 'KEMASIK' },
      { name: 'KEPUNG' },
      { name: 'KERANDANG' },
      { name: 'KERTEH' },
      { name: 'KIJAL' },
      { name: 'KUALA BERANG' },
      { name: 'KUALA BERANG TOWN' },
      { name: 'KUALA BESUT' },
      { name: 'KUALA DUNGUN' },
      { name: 'KUALA IBAI' },
      { name: 'KUALA NERUS TOWN' },
      { name: 'KUALA PAKA' },
      { name: 'KUALA TELEMUNG' },
      { name: 'KUBANG BEMBAN' },
      { name: 'KUBANG PARIT' },
      { name: 'KUMPAL' },
      { name: 'LOSONG' },
      { name: 'LUBUK KAWAH' },
      { name: 'MANIR' },
      { name: 'MERANG' },
      { name: 'MERCANG' },
      { name: 'PAKOH' },
      { name: 'PALUH' },
      { name: 'PANTAI' },
      { name: 'PASIR AKAR' },
      { name: 'PASIR RAJA' },
      { name: 'PASIR SEMUT' },
      { name: 'PELAGAT' },
      { name: 'PENGADANG BULUH' },
      { name: 'PENGHULU DIMAN' },
      { name: 'PENGKALAN BERANGAN' },
      { name: 'PENGKALAN NANGKA' },
      { name: 'PERHENTIANS ISLAND' },
      { name: 'PULAU KERENGGA' },
      { name: 'PULAU-PULAU' },
      { name: 'RASAU' },
      { name: 'REDANG ISLAND' },
      { name: 'RENGAS' },
      { name: 'RUSILA' },
      { name: 'SERADA' },
      { name: 'SURA' },
      { name: 'TANGGUL' },
      { name: 'TASIK' },
      { name: 'TEBAK' },
      { name: 'TELUK KALONG' },
      { name: 'TEMBILA' },
      { name: 'TENANG' },
      { name: 'TERSAT' },
      { name: 'TOK JAMAL' },
    ],
  },
];
